import i18next, { TOptions } from 'i18next'

export function translateValidationErrors(errors: Record<string, string | string[]>) {
  return Object.keys(errors).reduce((acc: Record<string, Array<string | string[] | null>>, key) => {
    const match = key.match(/^(.+)\[(\d+)\]$/)
    if (match) {
      const [_, field, index] = match

      if (!acc[field]) {
        acc[field] = [] as Array<string | string[] | null>
      }

      if (Array.isArray(errors[key])) {
        acc[field][parseInt(index)] = errors[key].map((error: string) =>
          i18next.t(error, { ns: 'validation', field: i18next.t(field, { ns: 'common' }) })
        )
      } else {
        acc[field][parseInt(index)] = [
          i18next.t(errors[key], { ns: 'validation', field: i18next.t(field, { ns: 'common' }) })
        ]
      }

      return acc
    }

    if (Array.isArray(errors[key])) {
      acc[key] = errors[key].map((error: string) =>
        i18next.t(error, { ns: 'validation', field: i18next.t(key, { ns: 'common' }) })
      )
    } else {
      acc[key] = [
        i18next.t(errors[key], { ns: 'validation', field: i18next.t(key, { ns: 'common' }) })
      ]
    }

    return acc
  }, {})
}

export function mustBeString(field: string) {
  return i18next.t('mustBeString', {
    ns: 'validation',
    field
  })
}

export function mustBeStringOrNull(field: string) {
  return i18next.t('mustBeStringOrNull', {
    ns: 'validation',
    field
  })
}

export function mustBeNumber(field: string) {
  return i18next.t('mustBeNumber', {
    ns: 'validation',
    field
  })
}

export function mustBeInteger(field: string) {
  return i18next.t('mustBeInteger', {
    ns: 'validation',
    field
  })
}

export function mustBeFloat(field: string) {
  return i18next.t('mustBeFloat', {
    ns: 'validation',
    field
  })
}

export function mustBeBoolean(field: string) {
  return i18next.t('mustBeBoolean', {
    ns: 'validation',
    field
  })
}

export function isRequired(field: string) {
  return i18next.t('isRequired', {
    ns: 'validation',
    field
  })
}

export function mustBeLessThanCharacters(field: string, max: number) {
  return i18next.t('mustBeLessThanCharacters', {
    ns: 'validation',
    field,
    max
  })
}

export function circularReference(field: string) {
  return i18next.t('circularReference', {
    ns: 'validation',
    field
  })
}
